<!--
 * @Description: 混凝土结算审批
 * @Author: wangwangwang
 * @Date: 2020-11-18 15:34:16
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-03-26 16:12:11
-->
<template>
  <div class="flows-content">
    <el-container>
      <el-main style="margin-bottom: 20px; padding: 0;">
        <el-container direction="vertical">
          <FlowHeader :isReadOnly="readOnly" @saveSubmit="handleSubmit(1)" @sendSubmit="handleSubmit(2)"
            @handleBackEnd="handleSubmit(3)" @handleCC="handleSubmit(4)" @handleAssign="handleSubmit(5)"
            @handleBackUp="handleSubmit(6)" @handleAssist="handleSubmit(7)" @handleNode="handleSubmit(8)"
            @handleNodeImage="handleSubmit(9)" @handleCollection="handleSubmit(10)" />
          <el-main class="info">
            <div>
              <el-input v-model="title" class="flow-title" :disabled="$route.query.type * 1 !== 1"
                placeholder="请输入流程标题"></el-input>
            </div>
            <div class="info-top">
              <div class="left">
                <span>单据号码：{{ billCode }}</span>
                <span class="text">制单日期：{{ billDate }}</span>
              </div>
              <div class="right">
                <span>发起人：{{ applyPerson }}</span>
                <span class="text">状态：{{ taskTypeText[taskStatus * 1] }}</span>
              </div>
            </div>
            <div>
              <div class="bill_top">
                <span><span class="text">结算工程：</span>{{ billDetails.engineeringName }}</span>
                <span><span class="text">合同单位：</span>{{ billDetails.collaborationUnitId }}</span>
                <!-- <span><span class="text">客户名称：</span>{{billDetails1.customer}}</span> -->
                <!-- <span><span class="text">公司：</span>{{billDetails1.company}}</span> -->
                <!-- <span><span class="text">站点名称：</span>{{billDetails1.stationName}}</span> -->
                <span><span class="text">结算时间：</span>{{ billDetails.startTime }}至{{ billDetails.endTime }}</span>
                <span><span class="text">结算单编号：</span>{{ billDetails.statementNo }}</span>
              </div>
              <div class="bill_title">产品结算</div>
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                style="width: 100%" :data="productDetailList" tooltip-effect="dark">
                <el-table-column label="时间段" align="center" width="175">
                  <template slot-scope="scope"> {{ scope.row.startTime }} - {{ scope.row.endTime }} </template>
                </el-table-column>
                <el-table-column label="产品名称" align="center" prop="productName">
                  <template slot-scope="scope"> {{ scope.row.productName }} </template>
                </el-table-column>
                <el-table-column label="签收数量（方）" align="center" prop="signNum"></el-table-column>
                <el-table-column label="车数（车）" align="center">
                  <template slot-scope="scope"> {{ scope.row.carNum }} </template>
                </el-table-column>
                <el-table-column label="产品组合" align="center" prop="productNameCompose"></el-table-column>
                <el-table-column label="单价（元/m³）" align="center" prop="composePrice"></el-table-column>
                <el-table-column label="强度等级单价（元/m³）" align="center" prop="strenghGradePrice">
                  <template slot-scope="a">
                    <el-input v-model="a.row.strenghGradePrice" disabled style="width:100%" type="Number"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="特添材料单价（元/m³）" align="center" prop="fillerMaterialPrice">
                  <template slot-scope="a">
                    <el-input v-model="a.row.fillerMaterialPrice" disabled style="width:100%" type="Number"></el-input>
                  </template>
                </el-table-column>
                <!-- <el-table-column label="合同单价（元/m³）" align="center" prop="basicPeice"></el-table-column> -->
                <el-table-column label="结算单价（元/m³）" align="center" prop="settlePrice"></el-table-column>
                <el-table-column label="结算金额（元）" align="center" prop="settleAccount"></el-table-column>
              </el-table>
              <div class="combined">
                小计：签收数量【{{ combined(productDetailList, '产品结算') }}】，结算金额【{{ combined1(productDetailList, '产品结算') }}】</div>
              <div class="bill_title">泵送结算</div>
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                style="width: 100%" :data="pumpDetailList" tooltip-effect="dark">
                <el-table-column label="泵类型" align="center" prop="pumpName"></el-table-column>
                <el-table-column label="生效时间" align="center" prop="effectTime"></el-table-column>
                <el-table-column label="泵送数量（方）" align="center" prop="pumpNum"></el-table-column>
                <el-table-column label="补差方量（方）" align="center" prop="repairDifferNum"></el-table-column>
                <el-table-column label="结算单价（元）" align="center">
                  <template slot-scope="a">
                    <el-input v-model="a.row.settlePrice" disabled style="width:100%" type="Number"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="结算金额（元）" align="center">
                  <template slot-scope="a">
                    {{ a.row.settlementAccount }}
                  </template>
                </el-table-column>
              </el-table>
              <div class="combined">小计：泵送数量【{{ combined(pumpDetailList, '泵送结算') }}】，结算金额【{{ combined1(pumpDetailList,
                '泵送结算')
              }}】
              </div>
              <div class="bill_title">超高层增加费</div>
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                style="width: 100%" :data="highStoreyDetailList" tooltip-effect="dark">
                <el-table-column label="高度（米）" align="center" prop="highInterval"></el-table-column>
                <el-table-column label="超高层方量（方）" align="center" prop="quantity"></el-table-column>
                <el-table-column label="结算单价（元）" align="center">
                  <template slot-scope="a">
                    <el-input v-model="a.row.settilmentPrice" disabled style="width:100%" type="Number"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="结算金额（元）" align="center">
                  <template slot-scope="a">
                    {{ a.row.settlementAccount }}
                  </template>
                </el-table-column>
              </el-table>
              <div class="combined">小计：超高层方量【{{ combined(highStoreyDetailList, '超高层增加费') }}】，结算金额【{{
                combined1(highStoreyDetailList, '超高层增加费')
              }}】
              </div>
              <div v-if="dataType == 1" class="bill_title">运输费用（车补）</div>
              <el-table v-if="dataType == 1" :header-cell-style="{ background: '#f3f6f9' }"
                :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="transportDetailList"
                tooltip-effect="dark">
                <el-table-column label="单价（元/车）" align="center" prop="price"></el-table-column>
                <el-table-column label="数量（车）" align="center" prop="quality"></el-table-column>
                <el-table-column label="结算金额（元）" align="center">
                  <template slot-scope="a">
                    {{ a.row.settleAcount }}
                  </template>
                </el-table-column>
              </el-table>
              <div v-if="dataType == 2" class="bill_title">运输费用（方补）</div>
              <el-table v-if="dataType == 2" :header-cell-style="{ background: '#f3f6f9' }"
                :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="transportDetailList"
                tooltip-effect="dark">
                <el-table-column label="运输方量（方）" align="center" prop="quality"></el-table-column>
                <el-table-column label="补差单价（元）" align="center" prop="price"></el-table-column>
                <el-table-column label="结算金额（元）" align="center">
                  <template slot-scope="a">
                    {{ a.row.settleAcount }}
                  </template>
                </el-table-column>
              </el-table>
              <div class="bill_title">特殊条款</div>
              <div><el-input v-model="spetailTerm" style="width:100%" placeholder="请输入特殊条款"></el-input></div>
              <div class="bill_title">
                结算补差费用
                <!-- <el-button size="mini" class="bottom_all" style="margin-left: 24px" @click="compensate = true">
                  <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                  选择补差数据
                </el-button> -->
              </div>
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                style="width: 100%" :data="settlementCompensate" tooltip-effect="dark">
                <el-table-column label="时间段" align="center" width="400">
                  <template slot-scope="scope"> {{ scope.row.compensateStartTime }} - {{ scope.row.compensateEndTime }}
                  </template>
                </el-table-column>
                <el-table-column label="产品名称" align="center" prop="productName"></el-table-column>
                <el-table-column label="签收数量（方）" align="center" prop="signNum"></el-table-column>
                <el-table-column label="原结算单价（元/m³）" align="center" prop="settlePrice"></el-table-column>
                <el-table-column label="补差单价（元/m³）" align="center" prop="compensatePrice"></el-table-column>
                <el-table-column label="结算补差金额（元）" align="center" prop="compensateAccount">
                  <template slot-scope="a">
                    {{ a.row.compensateAccount }}
                  </template>
                </el-table-column>
              </el-table>
              <div class="combined">小计：签收数量【{{ combined(settlementCompensate, '结算补差') }}】，结算补差金额【{{
                combined1(settlementCompensate, '结算补差') }}】
              </div>
              <div class="bill_title">
                调整金额
                <!-- <el-button size="mini" class="bottom_all"  style="margin-left: 24px" @click="addItem1()">
                  <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                  添加
                </el-button> -->
              </div>
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                style="width: 100%" :data="settlementAdjust" tooltip-effect="dark">
                <el-table-column label="站点" align="center" >
                  <template slot-scope="scope">
                    <el-select ref="stationName" v-model="scope.row.stationId" style="width: 100%" disabled placeholder="请选择调整类型"
                      @change="
                        $nextTick(() => {
                          scope.row.stationName = $refs.stationName.selectedLabel;
                        })
                        ">
                      <el-option v-for="item in stationList" :key="item.stationId" :label="item.stationName"
                        :value="item.stationId"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="调整类型" align="center">
                  <template slot-scope="scope">
                    <el-select ref="deductionType1" v-model="scope.row.adjustType" style="width: 100%" disabled
                      placeholder="请选择调整类型" @change="
                        $nextTick(() => {
                          scope.row.deductionType = $refs.deductionType1.selectedLabel;
                        })
                        ">
                      <el-option v-for="item in deductionTypes" :key="item.id" :label="item.itemName"
                        :value="item.id"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="调增/调减" align="center" prop="type">
                  <template slot-scope="scope">
                    <el-select ref="type" v-model="scope.row.addOrReduce" disabled style="width: 100%" placeholder="请选择">
                      <el-option :key="1" label="调增" :value="1"></el-option>
                      <el-option :key="0" label="调减" :value="0"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="调整金额" align="center">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.adjustAmount" placeholder="请输入" disabled style="width: 100%"
                      onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                      @input="scope.row.adjustAmount = $regExp.checkNum(scope.row.adjustAmount)"
                      @blur="scope.row.adjustAmount = $regExp.blurCheckNum(scope.row.adjustAmount)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="是否影响开票" align="center">
                  <template slot-scope="scope">
                    <el-radio-group v-model="scope.row.influenceInvoice" disabled>
                      <el-radio :label="1">是</el-radio>
                      <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                  </template>
                </el-table-column>
                <el-table-column label="备注" align="center">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.remark" disabled placeholder="请输入" style="width: 100%"
                      clearable></el-input>
                  </template>
                </el-table-column>
                <!-- <el-table-column label="操作" align="left" width="120">
                  <template slot-scope="scope">
                    <el-button size="mini" class="bottom_two" @click="delItem1(scope.$index)">
                      <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                      删除
                    </el-button>
                  </template>
                </el-table-column> -->
              </el-table>
              <div style="border-top: 0px" class="combined">小计：结算金额【{{ combined5(1) }}】元</div>
              <div class="bill_title">结算合计</div>
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                style="width: 100%" :data="settlementTotal" tooltip-effect="dark">
                <el-table-column label="工程" align="center" prop="engineeringName"></el-table-column>
                <el-table-column label="合同签订主体" align="center" prop="collaborationUnit"></el-table-column>
                <el-table-column label="产品费用（元）" align="center" prop="productCost"></el-table-column>
                <el-table-column label="泵送费用（元）" align="center" prop="pumpCost"></el-table-column>
                <el-table-column label="超高层增加费（元）" align="center" prop="highStoreyCost"></el-table-column>
                <el-table-column label="小方量运输费用（元）" align="center" prop="qualityTransportCost"></el-table-column>
                <el-table-column label="结算补差费用（元）" align="center" prop="makeCost"></el-table-column>
                <el-table-column label="调整金额（元，不影响开票）" align="center" prop="adjustCostNoEffect"></el-table-column>
                <el-table-column label="调整金额（元，影响开票）" align="center" prop="adjustCostEffect"></el-table-column>
                <el-table-column label="结算金额（元）" align="center" prop="settlementAccount"></el-table-column>
                <el-table-column label="开票金额（元）" align="center" prop="invoicingCost"></el-table-column>
              </el-table>
            </div>
            <div class="flows-details">
              <FlowContent ref="flowcontent" :title='title' :showSendVisible="showSendVisible"
                @handleCancel="handleCancel" @sendCode="sendCode" @handleFinish="handleFinish"
                @handleBusiness="handleBusiness" @changeAudio="changeAudio" @resetFlowState="resetFlowState" />
            </div>
          </el-main>
        </el-container>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import FlowContent from '@/components/WorkFlow/flowContent';
import FlowHeader from '@/components/WorkFlow/flowHeader';
import { getUserInfo } from "@/utils/auth.js";
import { _debounce } from "@/utils/utils.js";
import {
  get_statement_detail,
  update_status,
} from "@/api/wise/concrete.js";
import {get_detail_code} from '@/api/basedata/concrete.js'
import addTab from "@/common/addTab.js";
export default {
  components: {
    FlowContent,
    FlowHeader
  },
  data() {
    return {
      type: 0,
      title: '混凝土结算审批',
      billCode: '',
      billDate: '',
      applyPerson: '',
      taskTypeText: ['发起', '已保存', '审批中', '已完成', '撤销', '不通过'],
      taskStatus: 0,
      showSendVisible: false,
      readOnly: false,
      billDetails1: {
        map: {
          beton: [],
          pump: [],
          small: []
        }
      },
      totalList1: [
        { name: '混凝土', code: 'beton' },
        { name: '泵送', code: 'pump' },
        { name: '小方量运输', code: 'small' }
      ],
      deductionTypes: [
        { itemName: '产品费用', id: '1' },
        { itemName: '泵送费用', id: '2' },
        { itemName: '超高层增加费', id: '3' },
        { itemName: '小方量运输费', id: '4' },
        { itemName: '特殊条款', id: '5' },
      ],
      billDetails: [],
      settlementAdjust: [],
      highStoreyDetailList: [],
      transportDetailList: [],
      pumpDetailList: [],
      productDetailList: [],
      spetailTerm: '',
      dataType: 1,
      compensate_datePicker: [],
      compensate: false,
      compensateList: [],//结算补差
      settlementCompensate: [],
      settlementCompensate1: [],
      settlementTotal: [{//结算总计
        adjustCostEffect: 0,//调整金额(影响开票)
        adjustCostNoEffect: 0,//调整金额(不影响开票)
        collaborationUnit: "",//合同签订主体
        engineeringName: "",//工程名
        invoicingCost: 0,//开票金额
        makeCost: 0,//结算补差费用
        productCost: 0,//产品费用
        highStoreyCost: 0,//超高层费用
        pumpCost: 0,//泵送费用
        qualityTransportCost: 0,//小方量费用
        settlementNo: "",//结算单编号
        settlementAccount: 0
      }],
      statementNo:'',
      stationList:[],
    }
  },
  methods: {
    changeAudio(e) { //操作成功后修改审核状态]
      console.log('------------------changeAudio')
      const { query } = this.$route;
      console.log('query', query)
      let id;
      id = JSON.parse(query.dataContent).id
      let data = {
        statementNo: id,
        auditStatus: e,
      }
      console.log(data)
      update_status(data).then(res => {
        console.log(res)
      })
    },
    /**小计量*/
    combined(arr, nameType) {
      let num = 0
      console.log(arr, nameType)
      if (arr.length > 0) {
        arr.forEach(res => {
          if (nameType == '产品结算') {
            num = Number(res.signNum) + num
          } else if (nameType == '泵送结算') {
            num = Number(res.pumpNum) + num
          } else if (nameType == '超高层增加费') {
            num = Number(res.quantity) + num
          } else if (nameType == '结算补差') {
            num = Number(res.signNum) + num
          }
        })
      }
      console.log(nameType + '----------------------------------', num)
      return num?.toFixed(2)
    },
    /**小计金额*/
    combined1(arr, nameType) {
      console.log(arr)
      let num = 0
      if (arr.length > 0) {
        arr.forEach(res => {
          if (nameType == '产品结算') {
            num = Number(res.settleAccount) + num
          } else if (nameType == '泵送结算') {
            num = Number(res.settlementAccount) + num
          } else if (nameType == '超高层增加费') {
            num = Number(res.settlementAccount) + num
          } else if (nameType == '结算补差') {
            num = Number(res.compensateAccount) + num
          }
        })
      }
      console.log(nameType + '----------------------------------', num)
      return num?.toFixed(2)
    },
    /*调整金额合计type:1全部,2影响开票金额合计,3不影响开票金额合计 */
    combined5(type) {
      let num = 0;
      this.settlementAdjust.forEach(res => {
        if (type == 1) {
          num = res.addOrReduce ? num + Number(res.adjustAmount) : num - Number(res.adjustAmount);
        } else if (type == 2) {
          if (res.influenceInvoice == 1) {
            num = res.addOrReduce ? num + Number(res.adjustAmount) : num - Number(res.adjustAmount);
          }
        } else if (type == 3) {
          if (res.influenceInvoice == 0) {
            num = res.addOrReduce ? num + Number(res.adjustAmount) : num - Number(res.adjustAmount);
          }
        }
      });
      return num.toFixed(2);
    },
    combined4(arr) {
      let num = 0
      if (this.billDeta1 || this.billDeta) {
        arr.forEach(res => {
          num = this.combined1(this.billDetails1.map[res.code]) + num
        })
      }
      return num
    },
    /*结算金额合计type:1结算金额2开票金额 */
    combinedall(type) {
      let num = 0;
      let row = this.settlementTotal[0];
      let settlementAccount = 0;
      if (type == 1) {
        num = settlementAccount + Number(row.adjustCostEffect) + Number(row.adjustCostNoEffect) + Number(row.makeCost) + Number(row.productCost) + Number(row.highStoreyCost) + Number(row.pumpCost) + Number(row.qualityTransportCost)
      } else if (type == 2) {
        num = settlementAccount + Number(row.adjustCostEffect) + Number(row.adjustCostNoEffect) + Number(row.makeCost) + Number(row.productCost) + Number(row.highStoreyCost) + Number(row.pumpCost) + Number(row.qualityTransportCost) - Number(row.adjustCostNoEffect)
      }
      return num.toFixed(2);
    },
    //不同意回调
    resetFlowState() {
      this.handleBusiness();
    },
    handleBusiness() {
      const { query } = this.$route;
      const params = {
        process_success: {
          url: '/icps/system/sign/settlement/beton/betonStatement/update_status',
          data: {
            statementNo: JSON.parse(query.dataContent).id,
            auditStatus: 3,
            statusType: 1,
          },
          httpMethod: 'post',
        },
        process_failure: {
          url: '/icps/system/sign/settlement/beton/betonStatement/update_status',
          data: {
            statementNo: JSON.parse(query.dataContent).id,
            auditStatus: 4,
            statusType: 1,
          },
          httpMethod: 'post',
        }
      }
      this.showSendVisible = false;
      this.$refs.flowcontent.handleToFlow(params);
    },
    /**
     * @Description: 
     * @Param: 1为保存，2为最后提交
     * @Author: wangwangwang
     * @param {*} type
     */
    handleFinish(type) {
      const { query } = this.$route;
      if (type == 1) {
        update_status({
          statementNo: query.id,
          auditStatus: 2,
          statusType: 1,
        }).then((res) => {
          if (res.code == 1001) {
            addTab.$emit("remove", this.$route.name);
          }
        })
        return
      }
    },
    handleSubmit(type) {
      const { query } = this.$route;
      if (query.type * 1 === 2 && type === 2 && query.taskType * 1 !== 2) { // 发起流程
        this.showSendVisible = true;
        return
      }
      const data = {
        dataSource: 'sign_concrete',
        dataContent: JSON.stringify({ id: query.id }), // 业务数据
      }
      this.$refs.flowcontent.saveFlows(type, data);
    },
    handleFlowChat() {
      this.$refs.flowcontent.showFlowNode()
    },
    handleCancel() {
      this.showSendVisible = false;
    },
    /**
     * @Description: 回显业务数据
     * @Param: 
     * @Author: wangwangwang
     */
    initFlowsData(id) {
      var _this = this
      get_statement_detail({ settlementNo: id }).then(res => {
        // this.billDetails1 = res.data
        console.log(res.data)
        _this.billDetails = res.data.concreteSettlement
        _this.productDetailList = res.data.productDetailList  //产品
        _this.productDetailList.forEach(e => {
          if (e.historyLogistics !== null) {
            e.carNum = e.historyLogistics.length
          } else {
            e.carNum = 0
          }
        })
        _this.spetailTerm = res.data.concreteSettlement.spetailTerm
        _this.pumpDetailList = res.data.pumpDetailList //泵送
        _this.highStoreyDetailList = res.data.highStoreyDetailList //超高层
        _this.settlementCompensate = res.data.settlementCompensate
        _this.settlementAdjust = res.data.settlementAdjust
        if (res.data.transportDetailList) {
          _this.dataType = res.data.transportDetailList.dataType
          _this.transportDetailList.push(res.data.transportDetailList) //运输
        }
        _this.stationList = res.data.stationList
      })
      const { query } = this.$route;
      if (query.type * 1 !== 1) {
        this.title = query.taskName;
      }
      this.billCode = query.receiptNumber;
      this.billDate = query.createTime;
    },
    sendCode(code) {
      this.billCode = code;
    },
    /**结算合计*/
    settotalList: _debounce(function () {
      this.settlementTotal[0].adjustCostEffect = this.combined5(2);
      this.settlementTotal[0].adjustCostNoEffect = this.combined5(3);
      this.settlementTotal[0].collaborationUnit = this.billDetails.collaborationUnit;
      this.settlementTotal[0].engineeringName = this.billDetails.engineeringName;
      this.settlementTotal[0].makeCost = this.combined1(this.settlementCompensate, '结算补差');
      this.settlementTotal[0].productCost = this.combined1(this.productDetailList, '产品结算');
      this.settlementTotal[0].highStoreyCost = this.combined1(this.highStoreyDetailList, '超高层增加费');
      this.settlementTotal[0].pumpCost = this.combined1(this.pumpDetailList, '泵送结算');
      this.settlementTotal[0].qualityTransportCost = this.transportDetailList[0].settleAcount;
      this.settlementTotal[0].settlementNo = '';
      this.settlementTotal[0].settlementAccount = this.combinedall(1);
      this.settlementTotal[0].invoicingCost = this.combinedall(2);
    }),
    get_detail_code(){
      get_detail_code({code:'concreteAdjust'}).then(res => {
        if(res.code == 1001){
          this.deductionTypes = res.data.items
        }
      })
    },
  },
  watch: {
    /**结算合计*/
    tatol: {
      handler() {
        this.settotalList();
      },
      deep: true,
      immediate: false,
    },
  },
  computed: {
    tatol() {
      return {
        settlementCompensate: this.settlementCompensate,
        settlementAdjust: this.settlementAdjust,
        billDetails: this.billDetails
      };
    },
  },
  created() {
    const { query } = this.$route;
    this.titlestatus = Number(query.type)
    this.get_detail_code();
  },
  mounted() {
    const { query } = this.$route;
    if (query.type * 1 === 1) { // 发起流程
      this.initFlowsData(query.id);
      this.$refs.flowcontent.initBaseData('sign_concrete');
      this.billDate = new Date().Format('yyyy-MM-dd hh:mm:ss');
      this.applyPerson = getUserInfo().userRealName;
      return
    }
    this.initFlowsData(JSON.parse(query.dataContent).id);
    this.applyPerson = query.createUserName;
    this.taskStatus = query.taskStatus;
    if (query.isReadOnly * 1 === 1) {
      this.readOnly = true;
    }
  }
}
</script>
<style lang="scss" scoped>
.bill_top {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  line-height: 40px;

  .text {
    font-weight: 600;
    color: #000;
  }
}

.bill_title {
  font-size: 18px;
  font-weight: 600;
  padding: 15px 0;
}

.bill_title1 {
  font-size: 18px;
  font-weight: 600;
  padding: 20px 0;
}

.bill_subtitle {
  padding: 20px 0;

  >span {
    padding-right: 20px;
  }

  .text {
    color: #000;
  }
}

.combined {
  border: 1px solid #ebeef5;
  text-align: center;
  line-height: 40px;
}

.flows-details {
  margin-top: 20px;
}

.info {
  padding: 0 20px;
  background: #fff;

  .info-top {
    font-size: $font_size;
    color: #000000;
    @include discen_al;
    justify-content: space-between;
    height: 50px;
    border-top: 1px #e1e5ed solid;
    border-bottom: 1px #e1e5ed solid;

    .left {
      @include discen_al;
    }

    .text {
      margin-left: 60px;
    }
  }
}

.nav_title {
  @include discen_al;
  align-items: flex-end;

  >div {
    width: 4px;
    height: 24px;
    background: $bg_color;
    margin-right: 10px;
  }

  i {
    margin-left: 5px;
  }

  color: $bg_color;
  font-size: 20px;
  font-weight: bold;
}

.dialoginfo {
  padding: 0;
}

.active {
  border-top: 1px #e1e5ed solid;
  border-right: 1px #e1e5ed solid;
  border-left: 1px #e1e5ed solid;
  background: #fff;
}

.dialoginfo-info {
  border-right: 1px #e1e5ed solid;
  border-left: 1px #e1e5ed solid;
  border-bottom: 1px #e1e5ed solid;
}

/*弹窗*/
.dialoginfo-title {
  >div {
    cursor: pointer;
  }

  height: 48px;
  display: flex;
  background: linear-gradient(180deg,
    rgba(250, 252, 255, 1) 0%,
    rgba(245, 247, 250, 1) 100%);

  .none {
    font-weight: bold;
    height: 48px;
    @include discen;
    width: calc(calc(100% - 1px) / 2);
    border-bottom: 1px solid #e1e5ed;

    >div {
      line-height: 48px;
      border-bottom: 1px rgba(0, 0, 0, 0) solid;
    }
  }

  .center {
    width: 1px;
    height: 48px;
    background: #e1e5ed;
  }

  .active {
    font-weight: bold;
    height: 48px;
    @include discen;
    width: calc(calc(100% - 1px) / 2);
    border-bottom: 1px solid rgba(0, 0, 0, 0);

    >div {
      color: $bg_color;
      line-height: 48px;
      border-bottom: 1px $bg_color solid;
    }
  }
}

.dialoginfo-info {
  padding: 10px 20px;
  overflow: auto;
  height: calc(85vh - 282px);

  .el-select,
  .el-input,
  .el-date-picker {
    width: 100%;
  }
}

.form-title {
  font-size: 18px;
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
}
</style>